import { Col, Layout, Result, Row } from 'antd';
import React from 'react';
import { Navigate } from 'react-router-dom';

class ControllerPage404 extends React.Component {
  state = {
    _navigate: false,
  };

  onButton = () => {
    this.setState({ _navigate: true });
  };

  render = () => {
    const { Content } = Layout;

    if (this.state._navigate) {
      return <Navigate to="/" />;
    }

    return (
      <Content>
        <Row justify="center" style={{ height: '90vh', alignItems: 'center' }}>
          <Col span={24}>
            <Result
              status="404"
              subTitle="Desculpe, página não encontrada."
              title="404"
            />
          </Col>
        </Row>
      </Content>
    );
  };
}

export default ControllerPage404;
